var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ECEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.4917 7.66666H12.5083C9.475 7.66666 7.66667 9.47499 7.66667 12.5083V19.4833C7.66667 22.525 9.475 24.3333 12.5083 24.3333H19.4833C22.5167 24.3333 24.325 22.525 24.325 19.4917V12.5083C24.3333 9.47499 22.525 7.66666 19.4917 7.66666Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 14.125H12.875C12.5333 14.125 12.25 13.8417 12.25 13.5C12.25 13.1583 12.5333 12.875 12.875 12.875H19.125C19.4667 12.875 19.75 13.1583 19.75 13.5C19.75 13.8417 19.4667 14.125 19.125 14.125Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 19.125H12.875C12.5333 19.125 12.25 18.8417 12.25 18.5C12.25 18.1583 12.5333 17.875 12.875 17.875H19.125C19.4667 17.875 19.75 18.1583 19.75 18.5C19.75 18.8417 19.4667 19.125 19.125 19.125Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransact);
export default __webpack_public_path__ + "static/media/transact.b1f1ce2ad4f1d466aa9e8cddf45d60e8.svg";
export { ForwardRef as ReactComponent };